var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_292_39786)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6169 30.6383C53.6169 28.7582 52.0927 27.2341 50.2126 27.2341H29.7871C27.9069 27.2341 26.3828 28.7582 26.3828 30.6383V44.2553C26.3828 46.1355 27.9069 47.6596 29.7871 47.6596H46.1033C46.5547 47.6596 46.9877 47.8389 47.3069 48.1581L52.164 53.0153C52.7001 53.5514 53.6169 53.1717 53.6169 52.4135V30.6383ZM34.8935 37.4468C34.8935 38.3869 34.1314 39.149 33.1913 39.149C32.2513 39.149 31.4892 38.3869 31.4892 37.4468C31.4892 36.5068 32.2513 35.7447 33.1913 35.7447C34.1314 35.7447 34.8935 36.5068 34.8935 37.4468ZM41.702 37.4468C41.702 38.3869 40.9399 39.149 39.9998 39.149C39.0598 39.149 38.2977 38.3869 38.2977 37.4468C38.2977 36.5068 39.0598 35.7447 39.9998 35.7447C40.9399 35.7447 41.702 36.5068 41.702 37.4468ZM46.8083 39.149C47.7484 39.149 48.5105 38.3869 48.5105 37.4468C48.5105 36.5068 47.7484 35.7447 46.8083 35.7447C45.8683 35.7447 45.1062 36.5068 45.1062 37.4468C45.1062 38.3869 45.8683 39.149 46.8083 39.149Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_292_39786",
    x1: 80,
    y1: 0,
    x2: 0,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7936F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.77539225.svg";
export { ForwardRef as ReactComponent };